import { translate } from "./translate";

function getBaseUrl() {
    let baseUrl = process.env.VUE_APP_BASE_URL || '/';
    if (!baseUrl.endsWith('/')) {
        baseUrl += '/';
    }
    return baseUrl;
}

export function resolveImageSource(value = '') {
    if (value == null || value === '') {
        return null;
    }

    const raw = String(value).trim();

    if (
        raw.startsWith('http://') ||
        raw.startsWith('https://') ||
        raw.startsWith('data:image') ||
        raw.startsWith('blob:') ||
        raw.startsWith('/')
    ) {
        return raw;
    }

    if (
        raw.includes('/') ||
        raw.startsWith('profile_images') ||
        raw.startsWith('cover_images') ||
        raw.startsWith('professionals')
    ) {
        const apiBase = (process.env.VUE_APP_API_URL || 'https://api.jobifull.com/').replace(/\/?$/, '/');
        return `${apiBase}storage/${raw.replace(/^\//, '')}`;
    }

    return `data:image/png;base64,${raw}`;
}

export function getBase64(base64String = '', pureBase64 = false, placeholderImg = 'img/logo-icon-jobifull.png'){
    const baseUrl = getBaseUrl();
    const resolved = resolveImageSource(base64String);
    if(!resolved){
        if(pureBase64)
            return `${baseUrl}${placeholderImg}`;
        return `url(${baseUrl}${placeholderImg})`;
    }
    if(pureBase64)
        return resolved;
    return `url(${resolved})`;
}

export async function getOnPublicImagesUrl(fileName = '', defaultImage = 'img/logo-icon-jobifull.png'){
    const baseUrl = getBaseUrl();
    let requestedUrl = `${baseUrl}${fileName}`;
    const result = await resourceExists(requestedUrl);
    if(result){
        return requestedUrl;
    }else{
        return `${baseUrl}${defaultImage}`;
    }
}

export function getOnPublic(fileName = ''){
    return `${getBaseUrl()}${fileName}`;
} 

export async function resourceExists(url) {
    try {
      const response = await fetch(url, { method: 'HEAD' });
    //   if(!response.ok)
    //     console.clear();
      return response.ok;
    } catch (error) {
      return false;
    }
}

export function isImageValid(file){
    let response = {
        status: false,
        message: 'error'
    }
    const allowedMimeTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!allowedMimeTypes.includes(file.type)) {
        response.message = translate('accepted formats are: JPEG, PNG and GIF', 'ucfirst');
        return response;
    }
    const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
    if (file.size > maxSizeInBytes) {
        response.message = translate('max allowed size is 2 MB', 'ucfirst');
        return response;
    }
    response.status = true;
    return response;
}